import { formBuilderFieldsByType } from "../../Fields/index.js";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import warnOnce from "warn-once";
//#region src/modules/FormBuilder/components/FormBuilderDisplayRenderer/components/FieldDisplayRenderer.tsx
var FieldDisplayRenderer = ({ field }) => {
	return /* @__PURE__ */ jsx(useMemo(() => {
		const component = formBuilderFieldsByType[field?.type]?.DisplayLayout;
		if (component) return component;
		warnOnce(true, `<DisplayComponent field={{ type: "${field.type}", ...}} /> - not a recognized field type`);
		return () => null;
	}, [field.type]), { config: field });
};
//#endregion
export { FieldDisplayRenderer };

//# sourceMappingURL=FieldDisplayRenderer.js.map